<script>
    import Template from '../../Models/templateModel';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {confirm} from '../Confirmation.svelte';
    import {notifier} from '@beyonk/svelte-notifications';

    let templates = Template.getList();

    let form = {
        fields: [
            {
                name: "name",
                label: "Name",
                type: "text",
                required: true
            }
        ],
        title: "Add Template",
    }

    let table = [
        {
            field: "name",
            label: "Template Name"
        }
    ]

    function addTemplate() {
        addFormModal(form).then((data) => {
            Template.createItem(data).then(() => {
                notifier.success("Template Created")
            });;
        }).catch(e => {});
    }

    function deleteTemplate(template) {
        confirm(`Are you sure you want to delete ${template.name}?`).then(() => {
            let template_ = new Template(template._id);
            template_.delete().then(() => {
                notifier.success("Template Deleted")
            });;
        }).catch(() => {})
    }
</script>

<Loader loading={!$templates}>
    <div class="container is-fluid">
        <h1 class="title is-1">Libraries</h1>
        <SortableTable sortFields={table} tableData={$templates} actionsWidth="250">
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addTemplate}>Add Template</button>
                </div>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addTemplate}>Add Template</button>
                </div>
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={template}>
                <button class="button is-danger" on:click={() => deleteTemplate(template)}>Delete</button>
                <a class="button is-link" href="#/template/{template._id}">Open</a>
            </div>
        </SortableTable>
    </div>
</Loader>